import type { LogMessageType } from "@multimediallc/web-utils/types"

interface LogMessageProps {
    message: LogMessageType
}

export function LogMessage({ message }: LogMessageProps) {
    return <span data-testid="log-message">{message}</span>
}
